import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { prettyPrintMinutes } from '../../utilities/prettyPrintMinutes';

@Component({
  selector: 'lohi-number-badge',
  templateUrl: './number-badge.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NumberBadgeComponent implements OnInit {
  @Input() public count = 0;
  @Input() public bgClass = 'bg-red-500';
  @Input() public showIfZero = false;
  @Input() public currency = false;
  @Input() public prettyPrintMinutes = false;

  public get prettyPrintedMinutes(): string {
    return prettyPrintMinutes(this.count);
  }

  constructor() {}

  public ngOnInit(): void {}
}
